{
    "UsersByExtensions_ModalTitle": "Gebruikers",
    "UsersByExtensions_Filters": "Filters",
    "UsersByExtensions_AllPartitions": "Alle sites",
    "UsersByExtensions_Header_Users": "Uitbreiding - Volledige naam",
    "UsersByExtensions_Header_MS_Licences": "MS Licenties",
    "UsersByExtensions_UserFields_Email": "E-mail",
    "UsersByExtensions_UserFields_Type": "CXA-abonnement",
    "UsersByExtensions_UserFields_UseEmailAsUser": "Gebruik e-mail als gebruikersnaam",
    "UsersByExtensions_Username_Display_Title": "Gebruikersnaam",
    "UsersByExtensions_Username_Display_Title_No_Username": "Geen gebruikersnaam\n(Je kunt deze gebruiker niet aanmaken)",
    "UsersByExtensions_UserFields_LegacyAppend": "{} (Legacy)",
    "UsersByExtensions_UserType_Legacy_Akixi Lite": "Lite",
    "UsersByExtensions_UserType_Legacy_Akixi ONE": "EEN",
    "UsersByExtensions_UserType_Legacy_Akixi BLF": "Aanwezigheid",
    "UsersByExtensions_UserType_Legacy_Akixi 1000": "1000",
    "UsersByExtensions_UserType_Legacy_Akixi 2000": "2000",
    "UsersByExtensions_UserFields_Checkbox_Tooltip": "Gebruiker aanmaken\/bijwerken",
    "UsersByExtensions_UserFields_Cross_Tooltip": "Gebruiker verwijderen",
    "UsersByExtension_UserType_NONE": "Monitoring gedeactiveerd (zonder vergunning)",
    "UsersByExtension_UserType_ESSENTIALS": "Benodigdheden",
    "UsersByExtension_UserType_ESSENTIALS_MST": "CXA-standaard",
    "UsersByExtension_UserType_PROFESSIONAL": "Professioneel",
    "UsersByExtension_UserType_PROFESSIONAL_MST": "CXA Premium",
    "UsersByExtension_UserType_ENTERPRISE": "Onderneming",
    "UsersByExtension_UserType_ENTERPRISE_MST": "CXA Geavanceerd (Historisch)",
    "UsersByExtension_UserType_CALL_CENTRE_AGENT": "Callcenter Agent",
    "UsersByExtension_UserType_CALL_CENTRE_AGENT_MST": "CXA-premie",
    "UsersByExtension_UserType_CALL_CENTRE_SUPERVISOR": "Supervisor callcenter",
    "UsersByExtension_UserType_CALL_CENTRE_SUPERVISOR_MST": "CXA Geavanceerd",
    "UsersByExtension_UserType_IsNotAgent": "Deze gebruiker heeft een Agent als je hem dit Abonnement geeft, dan wordt de activiteit van de Agent niet langer gemonitord",
    "UsersByExtension_UserType_IsNone": "De extensie van deze gebruiker wordt niet langer bewaakt als u hem dit abonnement geeft.",
    "UsersByExtension_Users_Multiple_Errors": "Er zijn meerdere gebruikers toegewezen aan deze extensie: {}",
    "UsersByExtensions_ConfirmUserDelete": "Klik nogmaals om te bevestigen dat u de rapportagetoegang wilt verwijderen?",
    "UserByExtension_LicenceTypes_EV": "EV-licentie",
    "UserByExtension_LicenceTypes_None": "Teams Gebruiker",
    "LicenceSummary_Title": "Samenvatting licentie",
    "LicenceSummary_Headers_Type": "Type",
    "LicenceSummary_Headers_InUse": "In gebruik",
    "LicenceSummary_Types_Essentials": "Benodigdheden",
    "LicenceSummary_Types_Essentials_MST": "CXA-standaard",
    "LicenceSummary_Types_Professional": "Professioneel",
    "LicenceSummary_Types_Professional_MST": "CXA Premium",
    "LicenceSummary_Types_Enterprise": "Onderneming",
    "LicenceSummary_Types_Enterprise_MST": "CXA Geavanceerd (Historisch)",
    "LicenceSummary_Types_Unlicenced": "Onbevoegd",
    "AddAllUsers_Button_Title": "Gebruikers aanmaken voor alle niet-bewaakte extensies",
    "AddAllUsers_Button_Title_Interpolated": "Maak {} gebruikers aan voor alle niet-bewaakte extensies",
    "NoUsersAdded": "Er zijn geen gebruikers toegevoegd",
    "TooManyUsers_NoLicences": "Kan gebruiker {} niet toevoegen omdat er geen licenties beschikbaar zijn",
    "TooManyUsers_UsersPlural_LicenceNonPlural": "Kan {} gebruikers niet toevoegen omdat alleen {} licentie beschikbaar is",
    "TooManyUsers_UsersNonPlural_LicenceNonPlural": "Kan {} gebruiker niet toevoegen omdat alleen {} licentie beschikbaar is",
    "TooManyUsers_NoLicences_Plural": "Kan {} gebruikers niet toevoegen omdat er geen licenties beschikbaar zijn",
    "TooManyUsers": "Kan {} gebruiker niet toevoegen omdat alleen {} licenties beschikbaar zijn",
    "TooManyUsers_Plural": "Kan {} gebruikers niet toevoegen omdat er alleen {} licenties beschikbaar zijn",
    "SuccessfullyAddedUsers": "{} gebruikers met \"{}\" licentie succesvol gelicenseerd",
    "AddAllUsers_PromptMessage": "Gebruikers aanmaken voor alle niet-bewaakte extensies met \"{}\" licentie.\n\nAlle niet-opgeslagen wijzigingen gaan verloren. Weet je zeker dat je door wilt gaan?\n\n",
    "AddAllUsers_Confirm": "Bevestig",
    "AddAllUsers_Cancel": "Annuleren",
    "AddAllUsers_CreatingUsers": "{} gebruikers toevoegen met \"{}\" licentie...",
    "AddAllUsers_Loading": "Aan het laden...",
    "NAME": "UsersByExtension",
    "UsersByExtensions_UserFields_CRM_Integration": "CX-integratie",
    "UsersByExtension_CrmLicenceType_SOLO": "Solo CRM-integratie",
    "UsersByExtension_CrmLicenceType_TEAMS": "Teams CRM-integratie",
    "UsersByExtension_CrmLicenceType_UNITE": "CX-integratie",
    "UsersByExtension_CrmLicenceType_NONE": "Geen CRM-integratie",
    "LicenceSummary_Types_CallCentreAgent": "Callcenteragent",
    "LicenceSummary_Types_CallCentreAgent_MST": "CXA-premie",
    "LicenceSummary_Types_CallCentreSupervisor": "Supervisor van het callcenter",
    "LicenceSummary_Types_CallCentreSupervisor_MST": "CXA Geavanceerd",
    "LicenceSummary_Types_CXIntegration": "CX-integratie",
    "ProvisionAllCrm_Button_Title_Interpolated": "Gebruikers met licentie {} aanmaken\/bijwerken",
    "ProvisionAllCrm_PromptMessage": "Maak gebruikers aan voor alle niet-gecontroleerde extensies met {}. \n \n Alle niet-opgeslagen wijzigingen gaan verloren. Weet u zeker dat u wilt doorgaan? \n \n",
    "TooManyUsers_MaxTelSysCapReached": "Kan gebruiker {} niet toevoegen omdat dit het maximale aantal gebruikers dat door het telefoonsysteem is toegestaan, zou overschrijden",
    "TooManyUsers_MaxTelSysCapReached_Plural": "Kan geen {} gebruikers toevoegen omdat dit het maximale aantal gebruikers dat door het telefoonsysteem is toegestaan, zou overschrijden",
    "UsersByExtensions_UserFields_CX_Integration": "CX-integratie",
    "UsersByExtension_CxiLicenceType_SOLO": "Solo CRM-integratie",
    "UsersByExtension_CxiLicenceType_TEAMS": "Teams CRM-integratie",
    "UsersByExtension_CxiLicenceType_CXI": "CX-integratie",
    "UsersByExtension_CxiLicenceType_NONE": "Geen CRM-integratie",
    "ProvisionAllCxi_Button_Title_Interpolated": "Gebruikers aanmaken\/bijwerken met {}",
    "ProvisionAllCxi_PromptMessage": "Maak gebruikers aan voor alle niet-gecontroleerde extensies met \"{}\" CRM-integratie. \n \n Alle niet-opgeslagen wijzigingen gaan verloren. Weet u zeker dat u wilt doorgaan? \n \n",
    "UsersByExtension_UserType_ESSENTIALS_WxC": "WxC-gebruiker",
    "UsersByExtension_UserType_CALL_CENTRE_AGENT_WxC": "WxC-agent",
    "UsersByExtension_UserType_CALL_CENTRE_SUPERVISOR_WxC": "WxC-supervisor",
    "UsersByExtensions_UserFields_Welcome_Mail": "Stuur een welkomstmail",
    "UsersByExtension_CxiLicenceType_CX_INTEGRATION": "CX-integratie",
    "AddAllUsers_Send_Welcome_Email_Checkbox_Text": "Vink dit vakje uit als u **geen** welkomstmail naar alle gebruikers wilt sturen.",
    "SendWelcomeEmailTitle": "Welkomstmail opnieuw verzenden naar \"{}\"",
    "SendWelcomeEmailConfirm": "Wilt u de welkomstmail opnieuw verzenden naar \"{}\"?",
    "EmailSuccessMessage": "E-mail is succesvol verzonden naar \"{}\"",
    "EmailFailMessage": "Er is een onverwachte fout opgetreden bij het verzenden van de e-mail. Probeer het opnieuw.",
    "UsersByExtensions_UserFields_RestoreBtn_Tooltip": "Gebruiker herstellen",
    "UsersByExtensions_AllSecGroups": "[All]",
    "Telsys_MissingRoles_Day0": "Beperkte provisioning. Schakel beheerdersrechten in voor de TelSys-gebruiker.",
    "Telsys_MissingRoles_Day1": "Er is geen gebruikersbeheerdersmachtiging gevonden voor de TelSys-gebruiker. Ga voorzichtig te werk."
}